import { render, staticRenderFns } from "./ScoreDetail.vue?vue&type=template&id=4c470180&scoped=true&"
import script from "./ScoreDetail.vue?vue&type=script&lang=js&"
export * from "./ScoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./ScoreDetail.vue?vue&type=style&index=0&id=4c470180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c470180",
  null
  
)

export default component.exports